"use client";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs, ColorGray700 } from "@nxt-costco-com/forge-design-tokens";
const productInfoContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
const ProductTitle = styled(Text, {
  shouldForwardProp: (props) => props !== "productTileMaxLineNumber"
})(({
  productTileMaxLineNumber = 3
}) => {
  return {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: productTileMaxLineNumber,
    display: "-webkit-box",
    lineClamp: productTileMaxLineNumber,
    overflow: "hidden"
  };
});
const productDescriptionStyles = {
  color: ColorGray700
};
export {
  ProductTitle,
  productDescriptionStyles,
  productInfoContainerStyles
};
